export enum KanbanSwimlaneCriteria {
    ETA = 'eta',
    NORMAL_DURATION = 'normal_duration',
}
